export const PRIVACY_PROMPT = 'privacy-prompt-shown';
